import { useMemo } from 'react'
import { useSpaceComments } from './useSpaceComments'
import { spacesApi } from '@/api/spacesApi/spacesAPIclient'
import { useQueryClient } from '@tanstack/react-query'

export const useUnreadCommentsCount = (spaceId?: string) => {
  const { data: comments, isLoading } = useSpaceComments(spaceId ?? '')
  const queryClient = useQueryClient()

  const unreadCount = useMemo(() => {
    if (!comments) return 0
    return comments.filter((comment) => !comment.read).length
  }, [comments])

  const markCommentsAsRead = useMemo(() => {
    return async (commentIds: string[]) => {
      await spacesApi.post(`/comments/read`, {
        ids: commentIds,
        read: true,
      })
      // Invalidate the comments query to refetch with updated read state
      queryClient.invalidateQueries(['spaceComments', spaceId])
    }
  }, [queryClient, spaceId])

  return {
    unreadCount,
    isLoading,
    markCommentsAsRead,
  }
}
